
export interface ITag {
    id: number
    region_ids: number[]
    name: string
    config: null|any
    npis: null| ITagNpi[]
    created_at?: string,
    updated_at?: string,
}

export interface ITagValue {
    [key: number]: any;
}

export interface ITagNpi {
    id: number
    name: string
    region_id: number
    isWWConfig: boolean
}

export interface ITagPos {
    id: number,
    pos_id: number,
    hq_id: number,
    city: string,
    country_id: number,
    pos_name: string,
    tags: ITagValue[],
}


export interface ITagLog {
    id: number
    type: string
    original_filename: string|null
    filepath: string|null
    status: string|null
    user_id: number|null
    wave_id: number|null
    started_at: string|null
    finished_at: string|null
    duration_ms: number|null
    error: any
    steps: ITagLogStep[];
    metas: any;
}

export interface ITagLogStep {
    step: string;
    started_at: string;
    data: any;
}

export const isRunningImport = (log: ITagLog|null) => log && !["COMPLETED", "FAILED"].includes(log.status ?? "");